import React, { useEffect, useRef, useState } from 'react'

import DataContextProvider from './DataContext'
import Panel from '../../../../elem/panel/Panel'
import { pressureAggregatePanel as panelClassConfig } from '../../../../../utils/styles/panelStyles'
import AggregateHeader from './AggregateHeader'
import AggregateChart from './AggregateChart'
// import TimeWindowDropdown from './TimeWindowDropdown'
import ResetDropdown from './ResetDropDown'
import MeasureDropdown from './MeasureDropdown'
import GroupingDropDown from './GroupingDropDown'

const PressureAggregate = ({ width }) => {
    const chartHeaderRef = useRef(null)
    const [headerHeight, setHeaderHeight] = useState(0)

    useEffect(() => {
        if (!chartHeaderRef.current) return

        const updateHeaderHeight = () => {
            setHeaderHeight(chartHeaderRef.current.offsetHeight || 0)
        }

        updateHeaderHeight()

        const resizeObserver = new ResizeObserver(updateHeaderHeight)
        resizeObserver.observe(chartHeaderRef.current)

        return () => {
            if (chartHeaderRef.current) {
                resizeObserver.unobserve(chartHeaderRef.current)
            }
        }
    }, [])

    return (
        <Panel panelClassConfig={panelClassConfig(width)}>
            <div className="explorerWrapper">
                <DataContextProvider>
                    <AggregateHeader />
                    <div ref={chartHeaderRef}>
                        <ResetDropdown />
                        <MeasureDropdown />
                        <GroupingDropDown />
                    </div>
                    <AggregateChart headerHeight={headerHeight} />
                </DataContextProvider>
            </div>
        </Panel>
    )
}

export default PressureAggregate
